import { render } from "./swedbank-insert-user-info.vue?vue&type=template&id=4d29b0c2&scoped=true"
import script from "./swedbank-insert-user-info.vue?vue&type=script&lang=js"
export * from "./swedbank-insert-user-info.vue?vue&type=script&lang=js"

import "./swedbank-insert-user-info.vue?vue&type=style&index=0&id=4d29b0c2&scoped=true&lang=scss"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d29b0c2"]])

export default __exports__